import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { FormStepContainer } from '../../../../styles/FormStepContainer';
import { approvedScreenRegisterViewEvent, ccRatesEvent, creditCardRTREvent } from '../../../../tracking';
import { getPublishedOffers } from '../../../../../../domains/prospect/publishedOffers';

import Default from './MultiproductPersonalizedRate/Default';
import PaidMkt from './MultiproductPersonalizedRate/PaidMkt/PaidMkt';
import PersonalizedRate from './MultiproductPersonalizedRate/PersonalizedRate';

function MultiproductMagic({ publishedOffersLink }) {
  const [rates, setRates] = useState(null);
  const [experimentSource, setExperimentSource] = useState(null);

  useEffect(() => {
    approvedScreenRegisterViewEvent();
    creditCardRTREvent();
  }, []);

  const handleGetPublishedOffers = async () => {
    const response = await getPublishedOffers(publishedOffersLink);

    if (response?.experiments?.paid_marketing === true) {
      setExperimentSource('paid_marketing');
    } else if (response?.experiments?.foundational_test === true) {
      setExperimentSource('foundational_test');
    } else if (response?.experiments?.growth_comms === true) {
      setExperimentSource('growth_comms');
    } else {
      setExperimentSource('default');
    }

    if (experimentSource && experimentSource !== 'default') {
      if (response?.metadata?.revolving_interest_rate) {
        const interestRate = parseFloat(response.metadata.revolving_interest_rate);
        const percentage = (interestRate * 100).toFixed(2);
        setRates(percentage);
      } else {
        console.error('No interest rate found');
      }
    }
  };

  useEffect(() => {
    if (publishedOffersLink) {
      handleGetPublishedOffers();
      ccRatesEvent('rtr');
    }
  }, [publishedOffersLink]);

  const displayMultiproductScreen = () => {
    switch (experimentSource) {
      case 'paid_marketing':
        return (<PaidMkt showZeroRate={Number(rates) <= 0} />);
      case 'foundational_test':
      case 'growth_comms':
        return (<PersonalizedRate rates={rates} />);
      case 'default':
      default:
        return (<Default />);
    }
  };

  return (
    <FormStepContainer height="100%">
      { displayMultiproductScreen() }
    </FormStepContainer>
  );
}

MultiproductMagic.propTypes = {
  publishedOffersLink: PropTypes.string,
};

MultiproductMagic.defaultProps = {
  publishedOffersLink: '',
};

export default MultiproductMagic;
